module.exports = __webpack_public_path__ + "img/17.8fae8213.png";